import SellCoinsCampaignCreate from '@/views/Portal/SellCoinsCampaignCreate.vue';
import { Route } from '../../route.model';

const portalSellCoinsCampaignCreate = new Route(
  '/portal/sell-coins-campaign-create',
  'portal-sell-coins-campaign-create',
  SellCoinsCampaignCreate,
  {
    requiresAuth: true,
    isResponsive: true,
    zendesk: {
      disabled: true
    }
  }
);

export { portalSellCoinsCampaignCreate };
export default portalSellCoinsCampaignCreate;
